export interface Address {
    street: string
    streetNumber: string
    city: string
    postalCode: number
}

export class AddressFactory {
    static create(): Address {
        return {
            street: "",
            streetNumber: "",
            city: "",
            postalCode: 0
        }
    }
}
